import dayjs from 'dayjs';
import { whiteLabelStore } from 'Models/WhiteLabelStore';

/** Whether this client reads times on the 12-hour clock (7:15PM), which runs wider than 19:15. */
export const usesTwelveHourClock = () => whiteLabelStore.config.timeFormat !== 'TWENTY_FOUR_HOUR_TIME';

/**
 * Returns time as 7:15pm / 19:15
 */
export const formatStandardTime = (date?: Date | string) =>
	dayjs(date).format(usesTwelveHourClock() ? 'h:mmA' : 'HH:mm');

/**
 * The time and its AM / PM apart — "7:15" and "PM" — for a layout that sets the period smaller than the
 * digits. The period is empty on the 24-hour clock.
 */
export const formatStandardTimeParts = (date?: Date | string) => {
	const twelveHour = usesTwelveHourClock();
	return {
		time: dayjs(date).format(twelveHour ? 'h:mm' : 'HH:mm'),
		period: twelveHour ? dayjs(date).format('A') : '',
	};
};

/**
 * Returns a length of time as "45 min", "2 h" or "1 h 45 min".
 */
export const formatDurationMinutes = (minutes: number) => {
	const hours = Math.floor(minutes / 60);
	const rest = minutes % 60;
	if (hours === 0) {
		return `${rest} min`;
	}
	return rest === 0 ? `${hours} h` : `${hours} h ${rest} min`;
};
